import { render, staticRenderFns } from "./DidiMinimal.vue?vue&type=template&id=4e8624ae&scoped=true"
var script = {}
import style0 from "@/layouts/didi/styles.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./DidiMinimal.vue?vue&type=style&index=1&id=4e8624ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8624ae",
  null
  
)

export default component.exports